import {
  Action,
  Dropdown,
  DropdownProps,
  Icon,
  IconName,
  Text,
  useDropdown,
} from '@revolut-internal/ui-kit'

type Option = {
  label: string
  value: string
}

type ActionDropdownProps = Omit<DropdownProps, 'onSelect'> & {
  label: string
  options: Option[]
  value?: string
  description?: string
  icon?: IconName
  onSelect: (value: string) => void
}

const MIN_WIDTH = 200

export const ActionDropdown = ({
  value,
  label,
  description,
  icon,
  options,
  minWidth = MIN_WIDTH,
  onSelect,
  ...restProps
}: ActionDropdownProps) => {
  const dropdown = useDropdown()
  const selectedOption = options.find(option => option.value === value)

  return (
    <>
      <Action
        useEndIcon={
          icon || (
            <Icon name={dropdown.state ? '16/ChevronUp' : '16/ChevronDown'} size={12} />
          )
        }
        aria-label={label}
        {...dropdown.getAnchorProps()}
      >
        {selectedOption?.label ?? label}
      </Action>

      <Dropdown
        {...dropdown.getTargetProps()}
        minWidth={minWidth}
        role="listbox"
        autoClose
        {...restProps}
      >
        {description && (
          <Dropdown.Item disabled>
            <Text color="grey-tone-50">{description}</Text>
          </Dropdown.Item>
        )}
        {options.map(option => (
          // eslint-disable-next-line jsx-a11y/role-supports-aria-props
          <Dropdown.Item
            key={option.value}
            aria-pressed={value === option.value}
            use="button"
            role="option"
            onClick={() => onSelect(option.value)}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown>
    </>
  )
}
